import React, { useContext } from 'react'
import { RiDeleteBin6Line } from 'react-icons/ri'
import { FaPlus } from 'react-icons/fa'
import TaskCard from '../components/TaskCard'
import { USER_CONTEXT } from '../context/ContextProvider'
import { Link } from 'react-router-dom'
import AddTaskCard from '../components/AddTaskCard'

const TaskSection = ({ name, id }) => {
  let { data, setData } = useContext(USER_CONTEXT)
  let tasks = data.tasks?.filter(
    (e) => e.status == name && data.selectedGroup == e.group,
  )
  return (
    <div className="grid gap-y-3 h-fit">
      <div className="py-4 px-4 bg-[#0e0e0e] rounded-[10px] flex w-full justify-between">
        <p className="text-[#F6F6F6] text-lg font-medium">{name}</p>
        <div className="flex items-center gap-x-3">
          <RiDeleteBin6Line
            onClick={() => {
              setData({
                type: 'DELETE_TASK_COLUMN',
                payload: {
                  status: name,
                  group: data.selectedGroup,
                },
              })
            }}
            className="h-4 w-auto text-[#768396] hover:text-red-900 cursor-pointer transition-colors duration-200"
          />
          <Link to={'/create'} className="bg-[#4C5BFC] p-2 rounded-lg ">
            <FaPlus className="w-3 h-auto text-white" />
          </Link>
        </div>
      </div>
      {tasks.length > 0 ? (
        tasks?.map((task,i) => {
          return <TaskCard data={task} key={i}/>
        })
      ) : (
        <AddTaskCard />
      )}
    </div>
  )
}

export default TaskSection
